import { CurrencyUtils } from "../common/CurrencyUtils";
import { QueryByType } from "../domain/constants/QueryByType";
import { Sell } from "../domain/models/Sell";
import { HistoricRepository } from "../domain/repositories/HistoricRepository";
import { axiosApp } from './remote/AxiosFactory';
import { handleRemoteResponse } from './remote/hanldeRemoteResponse';
import { handleAxiosResult } from './remote/handleAxiosResult';

export class HistoricDataRepository implements HistoricRepository {
    async getHistoricMovementsFiltered(date: string, dateEnd: string, page: number, all: boolean): Promise<Sell[]> {
        const result = await handleAxiosResult(axiosApp().get(`/pos/movs/by/date/filter?&date_ini=${date}&date_end=${dateEnd}&pag=${page}&all=${all}`));
        return handleRemoteResponse(result, (json: any) => {
            return json.map((r: any) => {
                return new Sell({
                    ...r,
                    amount: CurrencyUtils.removeCurrency(r.amount),
                    comision: CurrencyUtils.removeCurrency(r.comision),
                })
            })
        })
    }

    async getHistoricMovementsByDate(queryBy: QueryByType, date: string, page: number, all: boolean): Promise<Sell[]> {
        const result = await handleAxiosResult(axiosApp().get(`/pos/movs/by/${queryBy}?&date=${date}&pag=${page}&all=${all}`));
        return handleRemoteResponse(result, (json: any) => {
            return json.map((r: any) => {
                return new Sell({
                    ...r,
                    amount: CurrencyUtils.removeCurrency(r.amount),
                    comision: CurrencyUtils.removeCurrency(r.comision),
                })
            })
        })
    }

    async getHistoricTransactionsByDate(queryBy: QueryByType, date: string, page: number, all: boolean): Promise<Sell[]> {
        const result = await handleAxiosResult(axiosApp().get(`/pos/ops/by/${queryBy}?&date=${date}&pag=${page}&all=${all}`))
        return handleRemoteResponse(result, (json: any) => {
            return json.map((r: any) => {
                return new Sell({
                    ...r,
                    amount: CurrencyUtils.removeCurrency(r.amount),
                    comision: CurrencyUtils.removeCurrency(r.comision),
                })
            })
        })
    }

    async getHistoricTransactionsFiltered(date: string, dateEnd: string, page: number, all: boolean): Promise<Sell[]> {
        const result = await handleAxiosResult(axiosApp().get(`/pos/ops/by/date/filter?date_ini=${date}&date_end=${dateEnd}&pag=${page}&all=${all}`))
        return handleRemoteResponse(result, (json: any) => {
            return json.map((r: any) => {
                return new Sell({
                    ...r,
                    amount: CurrencyUtils.removeCurrency(r.amount),
                    comision: CurrencyUtils.removeCurrency(r.comision),
                })
            })
        })
    }

}